// COLORS
export const textDarkColor = "#000000";
export const textMediumColor = "#808080";
export const textMediumGrayColor = "#828282";
export const textDarkGrayColor = "#3D3D3D";
export const textDarkerGrayColor = "#4D4D4D";
export const textEvenDarkerGrayColor = "#7A7A7A";
export const backgroundLightGrayColor = "#A5A5A5";
export const backgroundMediumColor = "#8A8A8A";
export const backgroundChillMediumColor = "#777"; //HA
export const backgroundMediumGrayColor = "#505050";
export const backgroundDarkGrayColor = "#414141";
export const darkColor = "#222222";
export const lightGrayColor = "#DFDFDF";
export const midGrayColor = "#3e3e3e"; //Fuck me fuck me fuck me
export const mediumGrayColor = "#aaa";
export const darkGrayColor = "#272727";
export const transparentDarkGrayColor = "rgba(61, 61, 61, 0.9)";
export const transparentDarkLandingGrayColor = "rgba(41, 41, 41, 0.6)";
export const transparentGrayColor = "rgba(189,189,189,.2)";
export const whiteColor = "#fff";
export const blackColor = "#000";
export const yellowColor = "#FFFF00";
export const almostWhiteColor = "#FAFAFA";
export const offWhiteColor = "#F1F1F1";
export const backgroundColor = "#F3F3F3";
export const backgroundBrighterColor = "#F4F4F4";
export const primaryColor = "#4F148F";
export const lightPrimaryColor = "#8722F2";
export const redPrimaryColor = "#e7234b";
export const transparentPrimaryColor = "rgba(79, 20, 143, 0.5)";
export const bitTransparentPrimaryColor = "rgba(79, 20, 143, 0.9)";
export const partialTransparentColor = "rgba(0,0,0,0.25)";
export const transparent50Color = "rgba(0,0,0,0.50)";
export const transparent10Color = "rgba(0,0,0,0.1)";
export const transparentWhiteColor = "rgba(255,255,255,.8)";
export const transparent60WhiteColor = "rgba(255,255,255,.6)";
export const goldColor = "#ffde34";
export const lightGreenColor = "#E7FFDD";
export const primaryGreenColor = "#1db653";
export const lightRedColor = "#FFCCCC";
export const primaryRedColor = "#ff4158";
export const lightOrangeColor = "#fed8b1";
export const errorColor = "#FF4C4C";
export const mobileAnalyticsDark = "#252525";
export const appBackgroundGrayColor = "#e5e5e5";
export const welcomePrimaryColor = "#0F90CC";
export const welcomeSecondaryColor = "#7B1652";
export const premiumPrimaryColor = "#1E9DCA";
export const premiumSecondaryColor = "#1F60A9 ";

//TODO: Cleanup -- hexcode regex: #[a-fA-F\d]{6}
//TODO: Cleanup -- rgba(

export let colorMode = (isLight) => {
  return {
    //Base Colors
    base: isLight ? "#fff" : "#0f0f0f", //whiteColor
    base1: isLight ? "#fafafa" : "#171717", //almostWhiteColor
    base2: isLight ? "#f3f3f3" : "#1d1d1d", //backgroundColor / backgroundBrighterColor
    base3: isLight ? "#f1f1f1" : "#232323", //offWhiteColor

    //Text Colors
    text: isLight ? "#000" : "#fff", //textDarkColor
    text1: isLight ? "#3d3d3d" : "#f0f0f0", //textDarkGrayColor
    text2: isLight ? "#4d4d4d" : "#e8e8e8", //textDarkerGrayColor - I know it doesn't make sense
    text3: isLight ? "#828282" : "#ababab", //textMediumGrayColor / textMediumColor
    text4: isLight ? "" : "#7a7a7a", // null / textDarkGrayColor. Made for country popup view
    textDisabled: isLight ? "#bdbdbd" : "#777",
    textPlaceholder: isLight ? "#bdbdbd" : "#555",

    //Gray Colors
    gray: isLight ? "#222" : "#dfdfdf", //darkColor
    gray1: isLight ? "#aaa" : "#888", //mediumGrayColor
    gray2: isLight ? "#dfdfdf" : "#2e2e2e", //lightGrayColor
    gray3: isLight ? "#efefef" : "#090909", //lightGrayColor

    //Background Colors
    background: isLight ? "#e6e6e6" : "#252525", //mobileAnalyticsDark / appBackgroundGrayColor
    background1: isLight ? "#414141" : "#414141", //backgroundDarkGrayColor
    background2: isLight ? "#505050" : "#505050", //backgroundMediumGrayColor
    background3: isLight ? "#777" : "#777", //backgroundChillMediumColor
    background4: isLight ? "#a5a5a5" : "#a5a5a5", //backgroundLightGrayColor
    background5: isLight ? "#e0e0e0" : "#292929", //Menu underlay

    //TransparentBase
    transparentBase: isLight ? "rgba(255,255,255,.85)" : "rgba(0,0,0,.9)", //transparentWhiteColor
    transparentBase1: isLight ? "rgba(255,255,255,.6)" : "rgba(0,0,0,.8)", //transparent60WhiteColor
    transparentBase2: isLight ? "rgba(255,255,255,.4)" : "rgba(15,15,15,.8)",
    transparentBase3: isLight ? "rgba(255,255,255,.8)" : "rgba(38,38,38,.8)", //transparent60WhiteColor
    transparentBase4: isLight ? "rgba(255,255,255,.8)" : "rgba(29,29,29,.8)", //transparent60WhiteColor
    transparentBase5: isLight ? "rgba(255,255,255,.8)" : "rgba(29,29,29,.5)", //transparent60WhiteColor
    transparentBaseContentContainer: isLight
      ? "rgba(255,255,255,.8)"
      : "rgba(35,35,35,.8)", // derived from transparentBase3, exactly matches ContentContainer default base3 color '#232323'

    //TransparentOpp
    transparentOpp: isLight ? "rgba(0,0,0,0.50)" : "rgba(255,255,255,0.50)", //transparent50Color
    transparentOpp1: isLight ? "rgba(0,0,0,0.25)" : "rgba(255,255,255,0.25)", //partialTransparentColor
    transparentOpp2: isLight ? "rgba(0,0,0,0.1)" : "rgba(255,255,255,0.1)", //transparent10Color

    //TransparentGray
    transparentGray: isLight
      ? "rgba(41, 41, 41, 0.6)"
      : "rgba(215, 215, 215, 0.6)", //transparentDarkLandingGrayColor
    transparentGray1: isLight
      ? "rgba(189,189,189,.2)"
      : "rgba(150, 150, 150, 0.2)", //transparentGrayColor
  };
};

export let colors = colorMode(false);

// FONTS
export const fonts = {
  primary: "Lato, sans-serif",
  heyAugust: "Hey August",
  indieFlower: "Indie Flower",
  unifrakturMaguntia: "UnifrakturMaguntia",
  dancingScript: "Dancing Script",
  caveat: "Caveat",
  karla: "Karla",
};

export const fontWeights = {
  thin: 300,
  regular: 400,
  extraBold: 900,
};

export const mobileFontWeights = {
  thin: "300",
  regular: "400",
  extraBold: "900",
};

export const navigatorStyle = {
  navigationBarColor: darkColor,
  navBarBackgroundColor: darkColor,
  navBarTextColor: whiteColor,
  navBarButtonColor: whiteColor,
  // statusBarTextColorScheme: 'light',
  navBarHidden: false,
};
